<template>
  <ListagemBase
    nomePlural="SupportTeamMembers"
    nomeSingular="SupportTeamMember"
    :headers="headers"
  >
  </ListagemBase>
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import { createSupportTeamMemberDataService } from "@/services/support/SupportTeamMemberDataService";

export default {
  name: "ListagemSupportTeamMembers",
  components: { ListagemBase },
  data() {
    const supportScope =
      this.$route?.meta?.supportScope || this.$route?.query?.escopo || null;
    return {
      DataService: createSupportTeamMemberDataService(supportScope),
      headers: [
        { text: this.$t("Pessoa"), value: "pessoa.nome", sortable: "true" },
        { text: this.$t("Email"), value: "pessoa.email", sortable: "false" },
        {
          text: this.$t("Notificar_novo_ticket"),
          value: "notificarNovo",
          sortable: "false",
        },
        { text: this.$t("Ativo"), value: "ativo", sortable: "false" },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
};
</script>

<style></style>
